import { types } from "react-bricks";

export type VerticalPadding = "none" | "s" | "m" | "l";

export const getVerticalPadding = (paddingVertical: VerticalPadding) => {
  switch (paddingVertical) {
    case "none":
      return "0px";
    case "s":
      return "3rem";
    case "m":
      return "6.875rem";
    case "l":
      return "10rem";
    default:
      return "0px";
  }
};

export const verticalPadSideProp = {
  name: "paddingVertical",
  label: "Padding",
  type: types.SideEditPropType.Select,
  shouldRefreshStyles: true,
  selectOptions: {
    display: types.OptionsDisplay.Select,
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "s" },
      { label: "Medium", value: "m" },
      { label: "Large", value: "l" },
    ],
  },
};
